module.exports = __webpack_public_path__ + "static/media/pic-das-steck-drin.c031767c.png";